
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection, LabelId_$reflection } from "../../../Shared/Shared.js";
import { union_type, class_type, bool_type, string_type, record_type, list_type, option_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Label_$reflection, DTO_WriteCategoryDto_$reflection, DTO_CategoryDetailsDto_$reflection } from "../../../Shared/Category.js";

export class State extends Record {
    constructor(CategoryId, Category, CategoryForm, AllCategories, FormState) {
        super();
        this.CategoryId = CategoryId;
        this.Category = Category;
        this.CategoryForm = CategoryForm;
        this.AllCategories = AllCategories;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Categories.Form.Types.State", [], State, () => [["CategoryId", option_type(LabelId_$reflection())], ["Category", RequestedValue$1_$reflection(DTO_CategoryDetailsDto_$reflection())], ["CategoryForm", DTO_WriteCategoryDto_$reflection()], ["AllCategories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetColorHex", "SetVisibleForUser", "SetParentCategory", "CreateCategory", "UpdateCategory", "CategorySaved", "CategoryFetched", "CategoriesFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Categories.Form.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", option_type(LabelId_$reflection())]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", DTO_CategoryDetailsDto_$reflection()]], [["Item", list_type(Label_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

